var map;
var markers = [];
var infoWindow;

function initMap() {
  var myLatLng = { lat: 51.2, lng: 10.45 }; // Center the map to Germany
  map = new google.maps.Map(document.getElementById('map'), {
    center: myLatLng,
    zoom: 7
  });

  infoWindow = new google.maps.InfoWindow();

  Papa.parse('https://docs.google.com/spreadsheets/d/e/2PACX-1vRdsp7syraxebfEMsVg3Y4nnIv4bDF7Mxgu9z1VpHsk6pLFT9zQSHm4xZMLrOiwQ66Pk05xt_QxtmJQ/pub?gid=0&single=true&output=csv', {
    download: true,
    header: true,
    complete: function(results) {
      if (results.errors.length > 0) {
        console.log("Error parsing Google Sheet data");
        return;
      }
      var stores = results.data.map(function (store, index) {
        store.originalIndex = index;
        return store;
      });
      displayStores(stores);
      showStoresMarkers(stores);
      setOnClickListener();
    }
  });
}

function displayStores(stores) {
  var groupedStores = stores.reduce(function (grouped, store) {
    var key = store.Country;
    if (!grouped[key]) {
      grouped[key] = [];
    }
    grouped[key].push(store);
    return grouped;
  }, {});

  for (var country in groupedStores) {
    groupedStores[country].sort(function (a, b) {
      return a.Name.localeCompare(b.Name);
    });
  }

  var storesHtml = '';
  for (var country in groupedStores) {
    storesHtml += '<h3>' + country + '</h3>';
    groupedStores[country].forEach(function(store){
      storesHtml += `
        <div class="store-container" data-store-index="${store.originalIndex}">
          <div class="store-container-background">
            <div class="store-info-container">
              <div class="store-name">
                <span>${store.Name}</span>
              </div>
            </div>
          </div>
        </div>
      `;
    });
  }
  document.getElementById('store-list').innerHTML = storesHtml;
}

function showStoresMarkers(stores) {
  var bounds = new google.maps.LatLngBounds();

  stores.forEach(function(store){
    var latlng = new google.maps.LatLng(parseFloat(store.Latitude), parseFloat(store.Longitude));
    var name = store.Name;
    var address = store.Address;
    var phone = store.Phone;
    var directionsUrl = 'https://www.google.com/maps/dir//'+store.Latitude+','+store.Longitude;

    var marker = new google.maps.Marker({
      position: latlng,
      map: map,
      title: name
    });

    google.maps.event.addListener(marker, 'click', function() {
      infoWindow.setContent('<div><strong>' + name + '</strong><br>' +
                            '' + address + '<br>' +
                            '<a href="'+directionsUrl+'" target="_blank">Get Directions</a></div>');
      infoWindow.open(map, marker);
      map.setZoom(12);
      map.setCenter(marker.getPosition());
    });

    markers.push(marker);
    bounds.extend(latlng);
  });

  map.fitBounds(bounds);
   map.setZoom(7);
      map.setCenter({lat: 51.2, lng: 10.45}  );
}

function setOnClickListener() {
  var storeElements = document.querySelectorAll('.store-container');
  storeElements.forEach(function(elem, index){
    elem.addEventListener('click', function(){
      var storeIndex = elem.getAttribute('data-store-index');
      google.maps.event.trigger(markers[storeIndex], 'click');
    });
  });
}